import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PersistenceFacade } from '@frontend-site/persistence';
import { SystemService, SystemStore } from '@frontend-site/shared/core';
import { System, SystemDetails, SystemTypes } from '@frontend-site/shared/data';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LastPageResolverForesightService } from './last-page-resolver-foresight.service';

@Injectable({ providedIn: 'root' })
export class LastPageResolver  {
    constructor(
        private router: Router,
        private persistence: PersistenceFacade,
        private lastPageResolverForesightService: LastPageResolverForesightService,
        private systemStore: SystemStore,
        private systemService: SystemService
    ) {}

    resolve(): Observable<boolean> {
        return this.systemStore.systems$.pipe(
            switchMap((systems: System[]) => {
                if (this.isSingleSystemOfTypeForesight(systems)) {
                    return this.systemService.loadSystemDetails(systems[0].id).pipe(
                        switchMap((systemDetails: SystemDetails) => {
                            if (systemDetails.projectIds.length > 1) {
                                return this.navigateToLastPage();
                            }
                            return this.lastPageResolverForesightService.resolveForesightSystem(systems[0]);
                        })
                    );
                }

                return this.navigateToLastPage();
            })
        );
    }

    private isSingleSystemOfTypeForesight(systems: System[]): boolean {
        return systems?.length === 1 && systems[0].accountType === SystemTypes.SALESFORCE;
    }

    private navigateToLastPage(): Promise<boolean> {
        const lastPageOrDefault = this.persistence.getLastPage();
        return this.router.navigateByUrl(lastPageOrDefault);
    }
}
